import { FC } from 'react'
import { Box } from '@/components/atoms/Grid'
import { BridgeProduct } from 'types/bridgeProduct'
import {
  ShowProductModal,
  withProductDetailPopup
} from '@/HOC/withProductDetailPopup'
import ProductsContainer from './productsContainer'
import { ListingData } from 'types/listingData'
import { ProductListingFetcher } from '@/components/organisms/productListing/productListingFetcher'
import BannersLayout, { BannersType } from './bannersLayout'

type Top100ProductsContainerProps = {
  data: ListingData<BridgeProduct>
  showProductModal?: ShowProductModal
  getNextProducts: (offset: number, limit: number) => Promise<BridgeProduct[]>
  productListingFetcher: ProductListingFetcher
} & Rest

const Top100ProductsContainer: FC<Top100ProductsContainerProps> = ({
  data,
  showProductModal,
  getNextProducts,
  productListingFetcher,
  ...rest
}) => (
  <Box
    textAlign="center"
    mb={50}
    flex="1"
    data-testid="productListingContainer"
    {...rest}
  >
    {data.banners && (
      <BannersLayout
        banners={data.banners}
        bannerDst={BannersType.Campaign}
        mb={{ desktop: 50, tablet: 50, mobile: 20 }}
        gridColumnGap={16}
        gridRowGap={16}
        data-testid="bannersLayout"
      />
    )}
    <ProductsContainer
      fetcher={productListingFetcher}
      data={data}
      action={showProductModal}
      getNextProducts={getNextProducts}
      showPager={true}
      list="list.topproducts"
    />
  </Box>
)

export default withProductDetailPopup(Top100ProductsContainer)
